import {ChangeDetectionStrategy, Component, inject, ViewEncapsulation} from '@angular/core';
import { ToolsBoxService } from '../../Services/tools.service';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'navBarComponent',
    templateUrl: 'navbar.component.html',
    imports: [NgClass, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavBarComponent {
  private readonly toolsBox = inject(ToolsBoxService);

  readonly pageName = this.toolsBox.pageName;

  isLoggedin() {
    return this.toolsBox.checkUserisLoggedIn();
  }

  isAdmin = () => this.toolsBox.isAdmin();
}
